module.exports = "https://cdn-assessment.mathletics.com/app/12/assets/fonts/cc3ef33c7f378f96eb76bef03bf4397a.woff2";